<template>
  <form>
    <v-snackbar
        v-model="snackbar"
        :color="snackColor"
        timeout="30000"
    >
      {{ snackText }}

      <template v-slot:action="{ attrs }">
        <v-btn
            text
            v-bind="attrs"
            @click="snackbar = false"
        >
          Schließen
        </v-btn>
      </template>
    </v-snackbar>
    <v-container>
      <v-card class="ma-4 pa-4 elevation-8">
        <v-card-title>Servereinstellungen</v-card-title>
        <v-row class="ma-1">
          <v-col>
            <v-text-field
                v-model="hostname"
                :error-messages="hostnameErrors"
                label="Hostname"
                hint="Hostname ohne Domainendung"
                :placeholder="hostnamePlaceholder"
                @input="$v.hostname.$touch()"
                @blur="$v.hostname.$touch()"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
                v-model="ipAddress"
                :error-messages="ipAddressErrors"
                label="IP-Adresse"
                :placeholder="ipAddressPlaceholder"
                @input="$v.ipAddress.$touch()"
                @blur="$v.ipAddress.$touch()"
            ></v-text-field>
          </v-col>

          <v-col
              cols="2">
            <v-text-field
                type="number"
                v-model="prefix"
                :error-messages="prefixErrors"
                label="Routing Prefix"
                :placeholder="prefixPlaceholder"
                min="0"
                max="32"
                @input="$v.prefix.$touch()"
                @blur="$v.prefix.$touch()"
            ></v-text-field>
          </v-col>
          <v-col
              cols="2">
            <v-text-field
                v-model="gatewayAddress"
                :error-messages="gatewayAddressErrors"
                label="Gateway-Adresse"
                :placeholder="gatewayAddressPlaceholder"
                @input="$v.gatewayAddress.$touch()"
                @blur="$v.gatewayAddress.$touch()"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row class="ma-1">
          <v-col>
            <v-text-field
                v-model="nameserver1"
                :error-messages="nameserver1Errors"
                label="Nameserver 1"
                :placeholder="nameserver1Placeholder"
                @input="$v.nameserver1.$touch()"
                @blur="$v.nameserver1.$touch()"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
                v-model="nameserver2"
                :error-messages="nameserver2Errors"
                label="Nameserver 2"
                :placeholder="nameserver2Placeholder"
                @input="$v.nameserver2.$touch()"
                @blur="$v.nameserver2.$touch()"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
                v-model="nameserver3"
                :error-messages="nameserver3Errors"
                label="Nameserver 3"
                :placeholder="nameserver3Placeholder"
                @input="$v.nameserver3.$touch()"
                @blur="$v.nameserver3.$touch()"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row class="ma-1">
          <v-col>
            <v-text-field
                v-model="dnsSearchDomain"
                :error-messages="dnsSearchDomainErrors"
                label="DNS Search Domain"
                :placeholder="dnsSearchDomainPlaceholder"
                @input="$v.dnsSearchDomain.$touch()"
                @blur="$v.dnsSearchDomain.$touch()"
            ></v-text-field>
          </v-col>

          <v-col>
            <v-text-field
                v-model="ntpServer"
                :error-messages="ntpServerErrors"
                label="NTP Server"
                :placeholder="ntpServerPlaceholder"
                @input="$v.ntpServer.$touch()"
                @blur="$v.ntpServer.$touch()"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row class="ma-1">

          <v-col>
            <v-select
                :items="suseProducts"
                v-model="suseProduct"
                label="SUSE Product"
            ></v-select>
          </v-col>
          <v-col>
            <v-checkbox
                v-model="enableProxy"
                label="Proxy server"
            >
            </v-checkbox>
          </v-col>
          <v-col>
            <v-text-field
                :disabled="!enableProxy"
                v-model="proxyHost"
                :error-messages="proxyHostErrors"
                label="Proxy Host"
                :placeholder="proxyHostPlaceholder"
                @input="$v.proxyHost.$touch()"
                @blur="$v.proxyHost.$touch()"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row class="ma-1">

          <v-col>
            <v-text-field
                v-show="false"
                :disabled="suseProduct === suseProductNames.OPENSUSE"
                v-model="regCode"
                :error-messages="regCodeErrors"
                label="Registrations Code"
                :placeholder="regCodePlaceholder"
                @input="$v.regCode.$touch()"
                @blur="$v.regCode.$touch()"
            ></v-text-field>
          </v-col>

          <v-col>
            <v-text-field
                v-show="false"
                :disabled="suseProduct === suseProductNames.OPENSUSE"
                v-model="email"
                :error-messages="emailErrors"
                label="Email"
                :placeholder="emailPlaceholder"
                @input="$v.email.$touch()"
                @blur="$v.email.$touch()"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card>

      <v-card class="ma-4 pa-4 elevation-8">
        <v-card-title>Dienste</v-card-title>
        <v-row class="ma-1">
          <v-col>
            <v-checkbox
                v-model="enableFirewalld"
                label="Firewalld aktivieren"
            >
            </v-checkbox>
          </v-col>
          <v-col>
            <v-checkbox
                v-model="registerSaltMinion"
                label="Salt aktivieren"
            >
            </v-checkbox>
          </v-col>
        </v-row>
      </v-card>

      <v-card class="ma-4 pa-4 elevation-8">
        <v-btn
            class="mr-4 primary"
            @click="submit"
        >
          Senden
        </v-btn>

        <v-btn @click="clear" class="secondary">
          Zurück setzen
        </v-btn>
      </v-card>
    </v-container>
  </form>
</template>

<script>
import SUSEProducts from "@/config/suseProducts";

import axios from "@/utils/axios"
import { validationMixin } from 'vuelidate'
import { required, ipAddress, email, requiredIf } from 'vuelidate/lib/validators'
import suseProducts from "@/config/suseProducts";
import { getDetails } from "@/utils/auth";

export default {
  mixins: [validationMixin],

  validations: {
    hostname: {required},
    nameserver1: {required, ipAddress},
    nameserver2: {ipAddress},
    nameserver3: {ipAddress},
    ipAddress: {required, ipAddress},
    gatewayAddress: {required, ipAddress},
    ntpServer: {required},
    regCode: {
      required: requiredIf(function () {
        return this.suseProduct !== suseProducts.OPENSUSE
      })
    },
    email: {
      required: requiredIf(function () {
        return this.suseProduct !== suseProducts.OPENSUSE
      }), email
    },
    prefix: {required, minValue: val => val >= 0, maxValue: val => val <= 32},
    proxyHost: {
      required: requiredIf(function () {
        return this.enableProxy
      })
    },
    dnsSearchDomain: {required}
  },

  data: () => ({
    snackbar: false,
    snackColor: 'blue',
    snackText: '',
    hostname: '',
    hostnamePlaceholder: '',
    nameserver1: '',
    nameserver2: '',
    nameserver3: '',
    gatewayAddress: '',
    ipAddress: '',
    prefix: '',
    ntpServer: '',
    dnsSearchDomain: '',
    proxyHost: '',
    enableProxy: true,
    suseProductNames: SUSEProducts,
    suseProducts: [
      {value: SUSEProducts.SLES, text: SUSEProducts.SLES.description},
      {value: SUSEProducts.SLES4SAP, text: SUSEProducts.SLES4SAP.description},
      {value: SUSEProducts.OPENSUSE, text: SUSEProducts.OPENSUSE.description}
    ],
    suseProduct: SUSEProducts.SLES,
    enableFirewalld: true,
    registerSaltMinion: true
  }),
  created: function () {
    this.nameserver1 = this.settings.nameserver1
    this.nameserver1Placeholder = this.settings.nameserver1
    this.nameserver2 = this.settings.nameserver2
    this.nameserver2Placeholder = this.settings.nameserver2
    this.nameserver3 = this.settings.nameserver3
    this.nameserver3Placeholder = this.settings.nameserver3
    this.ipAddressPlaceholder = this.settings.ipAddress
    this.prefix = this.settings.prefix
    this.prefixPlaceholder = this.settings.prefix
    this.ntpServer = this.settings.ntpServer
    this.ntpServerPlaceholder = this.settings.ntpServer
    this.gatewayAddress = this.settings.gatewayAddress
    this.gatewayAddressPlaceholder = this.settings.gatewayAddress
    this.regCode = this.settings.regCode
    this.regCodePlaceholder = this.settings.regCode
    this.email = this.settings.email
    this.emailPlaceholder = this.settings.email
    this.dnsSearchDomain = this.settings.dnsSearchDomain
    this.dnsSearchDomainPlaceholder = this.settings.dnsSearchDomain
    this.proxyHost = this.settings.proxyHost
    this.proxyHostPlaceholder = this.settings.proxyHost
    this.suseProduct = SUSEProducts.getByName(this.settings.defaultOs)
  },
  computed: {
    settings() {
      return getDetails().settings
    },
    hostnameErrors() {
      const errors = []
      if (!this.$v.hostname.$dirty) return errors
      !this.$v.hostname.required && errors.push('Hostname ist ein Pflichtfeld.')
      return errors
    },
    nameserver1Errors() {
      const errors = []
      if (!this.$v.nameserver1.$dirty) return errors
      !this.$v.nameserver1.required && errors.push('Nameserver 1 ist ein Pflichtfeld.')
      !this.$v.nameserver1.ipAddress && errors.push('Muss eine IPv4 Adresse sein.')
      return errors
    },
    nameserver2Errors() {
      const errors = []
      if (!this.$v.nameserver2.$dirty) return errors
      !this.$v.nameserver2.ipAddress && errors.push('Muss eine IPv4 Adresse sein.')
      return errors
    },
    nameserver3Errors() {
      const errors = []
      if (!this.$v.nameserver3.$dirty) return errors
      !this.$v.nameserver3.ipAddress && errors.push('Muss eine IPv4 Adresse sein.')
      return errors
    },
    dnsSearchDomainErrors() {
      const errors = []
      if (!this.$v.dnsSearchDomain.$dirty) return errors
      !this.$v.dnsSearchDomain.required && errors.push('DNS Search Domain ist ein Pflichtfeld.')
      return errors
    },
    ntpServerErrors() {
      const errors = []
      if (!this.$v.ntpServer.$dirty) return errors
      !this.$v.ntpServer.required && errors.push('NTP Server ist ein Pflichtfeld.')
      return errors
    },
    ipAddressErrors() {
      const errors = []
      if (!this.$v.ipAddress.$dirty) return errors
      !this.$v.ipAddress.required && errors.push('IP-Adresse ist ein Pflichtfeld.')
      !this.$v.ipAddress.ipAddress && errors.push('Muss eine IPv4 Adresse sein.')
      return errors
    },
    prefixErrors() {
      const errors = []
      if (!this.$v.prefix.$dirty) return errors
      !this.$v.prefix.minValue || !this.$v.prefix.maxValue && errors.push('Bitte einen Wert zwischen 0 und 32 verwenden.')
      !this.$v.prefix.required && errors.push('Routing Prefix ist ein Pflichtfeld.')
      return errors
    },
    gatewayAddressErrors() {
      const errors = []
      if (!this.$v.gatewayAddress.$dirty) return errors
      !this.$v.gatewayAddress.ipAddress && errors.push('Muss eine IPv4 Adresse sein.')
      !this.$v.gatewayAddress.required && errors.push('Gateway-Adresse ist ein Pflichtfeld.')
      return errors
    },
    regCodeErrors() {
      const errors = []
      if (!this.$v.regCode.$dirty) return errors
      !this.$v.regCode.required && errors.push('Registrations Code ist ein Pflichtfeld.')
      return errors
    },
    emailErrors() {
      const errors = []
      if (!this.$v.email.$dirty) return errors
      !this.$v.email.email && errors.push('Muss eine E-Mail-Adresse sein.')
      !this.$v.email.required && errors.push('E-Mail-Adresse ist ein Pflichtfeld.')
      return errors
    },
    proxyHostErrors() {
      const errors = []
      if (!this.$v.proxyHost.$dirty) return errors
      !this.$v.proxyHost.required && errors.push('Proxy ist ein Pflichtfeld, wenn aktiviert.')
      return errors
    }
  },

  methods: {
    submit() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        const data = {
          hostname: this.hostname,
          nameserver1: this.nameserver1,
          nameserver2: this.nameserver2,
          nameserver3: this.nameserver3,
          ipAddress: this.ipAddress,
          prefix: this.prefix,
          gatewayAddress: this.gatewayAddress,
          regCode: this.regCode,
          email: this.email,
          dnsSearchDomain: this.dnsSearchDomain,
          ntpServer: this.ntpServer,
          enableProxy: this.enableProxy,
          proxyHost: this.enableProxy ? this.proxyHost : "",
          suseProduct: this.suseProduct.description,
          enableFirewalld: this.enableFirewalld,
          registerSaltMinion: this.registerSaltMinion
        }
        axios.post("/api/v1/createYast", data)
            .then((response) => {
              this.snackbar = true
              this.snackColor = 'green'
              this.snackText = `XML Datei generiert: ${ this.buildUrl(response.data) }`
            })
            .catch((err) => {
              this.snackbar = true
              this.snackColor = 'red'
              this.snackText = `Fehler beim Senden: ${ err }`
            })
      }
    },
    clear() {
      this.$v.$reset()
      this.hostname = ''
      this.nameserver1 = this.settings.nameserver1
      this.nameserver2 = this.settings.nameserver2
      this.nameserver3 = this.settings.nameserver3
      this.ipAddressPlaceholder = this.settings.ipAddress
      this.ipAddress = ''
      this.prefix = this.settings.prefix
      this.gatewayAddress = this.settings.gatewayAddress
      this.regCode = this.settings.regCode
      this.email = this.settings.email
      this.dnsSearchDomain = this.settings.dnsSearchDomain
      this.ntpServer = this.settings.ntpServer
      this.enableProxy = true
      this.proxyHost = this.settings.proxyHost
      this.enableFirewalld = true
      this.registerSaltMinion = true
    },
    buildUrl(relativeLink) {
      return `${ window.location.origin }/${ relativeLink }`
    }
  },
}
</script>
